import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  FormControl, InputLabel, Input, InputAdornment, IconButton,
} from '@material-ui/core';
import red from '@material-ui/core/colors/red';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { withStyles } from '@material-ui/core/styles';


class PasswordField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
      isDirty: false,
    };
  }

  renderError = () => {
    const { isDirty } = this.state;
    const {
      value, required,
    } = this.props;

    const errorMessage = {
      color: red[500],
      fontSize: 10,
      marginTop: 3,
    };

    if (required && isDirty && !value) {
      return (<p style={errorMessage}>Dieses Feld ist ein Pflichtfeld</p>);
    }

    return null;
  }

  handleChange = (event) => {
    const { isDirty } = this.state;
    const { onChange } = this.props;

    if (!isDirty) {
      this.setState({
        isDirty: true,
      });
    }

    onChange(event);
  }

  render() {
    const {
      classes, label, value, placeholder,
    } = this.props;
    const { showPassword } = this.state;

    return (
      <FormControl className={classes.root}>
        <InputLabel shrink htmlFor="adornment-password">{label}</InputLabel>
        <Input
          id="adornment-password"
          type={showPassword ? 'text' : 'password'}
          value={value || undefined}
          className={classes.root}
          placeholder={placeholder}
          error={this.renderError() !== null}
          {...this.props}
          onChange={this.handleChange}
          endAdornment={(
            <InputAdornment position="end">
              <IconButton
                aria-label="Toggle password visibility"
                onClick={() => this.setState({ showPassword: !showPassword })}
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          )}
        />
        {this.renderError()}
      </FormControl>
    );
  }
}

PasswordField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  classes: PropTypes.object.isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
};

PasswordField.defaultProps = {
  value: '',
  label: '',
  placeholder: '',
  required: false,
  onChange: () => {},
};

const styles = () => ({
  root: {
    marginTop: 14,
    display: 'flex',
    'label[data-shrink=false] + & ::-webkit-input-placeholder': {
      opacity: '0.5 !important',
    },
  },
  formControl: {
    background: '#fff',
  },
  input: {
    paddingLeft: '7px',
  },
});

export default withStyles(styles)(PasswordField);
